var _ellipse, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 31,
    viewBox: "0 0 40 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 8,
    rx: 7,
    ry: 8,
    fill: "#404040"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 27C26 31.4183 20.1797 30 13 30C5.8203 30 0 31.4183 0 27C0 22.5817 5.8203 17 13 17C20.1797 17 26 22.5817 26 27Z",
    fill: "#404040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 2C30.9052 2 33 4.15489 33 7C33 9.84511 30.9052 12 28.5 12C26.0948 12 24 9.84511 24 7C24 4.15489 26.0948 2 28.5 2Z",
    stroke: "#404040",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.105 15.9813C26.2827 15.2028 29.2054 14.9204 31.7099 15.2267C32.9591 15.3795 34.0494 15.6721 34.8679 16.0827C35.6931 16.4966 36.1426 16.9763 36.3145 17.4572C36.83 18.8991 36.8155 20.1853 36.2688 21.263C35.7179 22.349 34.5355 23.4031 32.3479 24.1852C31.2315 24.5843 30.5685 24.6544 30.1795 24.6006C29.8696 24.5576 29.7034 24.436 29.5452 24.1926C29.3441 23.8834 29.1875 23.4172 28.9972 22.7033C28.8198 22.0376 28.6195 21.1826 28.3106 20.3187C27.9182 19.2211 27.0577 18.4213 26.2435 17.8323C25.435 17.2474 24.4923 16.7518 23.8844 16.3941C23.7631 16.3228 23.6579 16.2556 23.5647 16.1962C23.7079 16.1324 23.8857 16.0597 24.105 15.9813Z",
    stroke: "#404040",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.3c92b86bc1fb00e8bce3f26dd37263d7.svg";
export { ForwardRef as ReactComponent };